// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	CancelButton: 'cancel-button',
	SaveButton: 'save-button',
	DatePaidDatePicker: 'date-paid-date-picker',
	Description: 'description',
	Amount: 'amount',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
